import CryptoPayoutViewContainer from './container';

export const CryptoPayoutViewRoute = CryptoPayoutViewContainer;
